import SecureStorage from '../../helpers/secure_storage';

/**
 * Obtiene datos de la sesión del usuario
 * 
 * IMPORTANTE: Para tokens de autenticación, usa SecureStorage directamente:
 * - SecureStorage.getAccessToken() para el access_token
 * - SecureStorage.getRefreshToken() para el refresh_token
 * 
 * Esta función es para datos del usuario como: nombre, email, rol, etc.
 * 
 * @param {string} parametro - El nombre del campo a obtener
 * @returns {any} - El valor del campo o cadena vacía si no existe
 */
export const DatosSesion = (parametro) => {
  try {
    // ⭐ Para tokens, usar SecureStorage (fuente única de verdad)
    if (parametro === "access_token") {
      const token = SecureStorage.getAccessToken();
      if (!token) {
        console.warn("DatosSesion: No hay access_token disponible. Considera usar SecureStorage.getAccessToken() directamente.");
      }
      return token || "";
    }
    
    if (parametro === "refresh_token") {
      const token = SecureStorage.getRefreshToken();
      return token || "";
    }
    
    // Para otros datos, usar authUser
    const authUser = SecureStorage.getAuthUser();
    
    if (!authUser) {
      //console.log("DatosSesion: No se encontró authUser en localStorage");
      return "";
    }
    
    // Depuración para ver qué datos están disponibles
    if (parametro === "debug") {
      return authUser;
    }
    
    
    
    return authUser[parametro] || "";
  } catch (error) {
    console.error("Error en DatosSesion:", error);
    return "";
  }
};
